import axios, { AxiosError, AxiosResponse } from "axios";
import { useUserStore } from "@src/stores/userStore";
import toast from "react-hot-toast";

//https://stackoverflow.com/questions/47216452/how-to-handle-401-authentication-error-in-axios-and-react
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        "Content-Type": "application/json", // Set the default content type for requests
    },
});
api.interceptors.response.use(
    (response: AxiosResponse) => {
        if (response.data.errors) {
            const errors = response.data.errors;
            if (errors !== undefined) {
                Object.keys(errors).map((error) => {
                    if (error == "current_password") {
                        toast.error("Wrong password");
                    } else {
                        toast.error(`${error} - ${errors[error]}`);
                    }
                });
            }
        }
        return response;
    },
    (axiosError: AxiosError) => {
        if (axiosError.response!.status == 401 || axiosError.status == 401) {
            // Log out user here
            useUserStore.getState().logout();
        }
        try {
            const error = axiosError.response;
            if (error !== undefined) {
                if (typeof error.data == "string") {
                    toast.error(error.data);
                } else {
                    toast.error(
                        `${error.statusText} - ${Object.values(error.data!).map(
                            (el) => {
                                if (typeof el == "object") {
                                    return Object.values(el).map(
                                        (errMessage) => errMessage,
                                    );
                                }
                            },
                        )}`,
                    );
                }
            }
        } catch (err) {
            toast.error(`Something happened, try again later: ${axiosError}`);
        }

        return Promise.reject(axiosError);
    },
);

api.interceptors.request.use(function(config) {
    const token = localStorage.getItem("token");
    if (token) { config.headers.Authorization = "Bearer " + token } else {
        config.headers.Authorization = undefined;
    }

    return config;
});
export { api };
